<template>
  <div id="article-result" class="tags-container click-outside-categories-ignore"
       v-on:click="onArticleMentionsClick">
    <div
        v-for="(category, key) in categoryMentionKeys"
        :key="key"
        :class="'click-outside-categories-ignore tag-category-wrapper '+stringToClass(category.name)"
        :id="'article-result-'+stringToClass(category.name)"
        :category-key="category.key">
      <label>{{category.name}}</label>

      <app-mention-tag
          v-for="(tag, key) in mentions.filter(t => t.parent === category.key)"
          :key="key"
          :parentContainerId="'article-result-'+stringToClass(category.name)"
          :tag="tag"
          :relationTag="getRelationTag(tag)"
          activeOrganization="articleLevel"
          :keysPressed="keysPressed"
          @deleteMentionTag="callDeleteMentionTag"
          @deleteRelationMentionTag="$emit('deleteRelationMentionTag', $event)"
          @updateMentionSentiment="$emit('updateMentionSentiment', $event)"
          @recordAction="$emit('recordAction', $event)"
          @showRelationTagMenu="$emit('showRelationTagMenu', $event)"
      />
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';

  import MentionTag from './mention_tag';

  import editor from '../../helpers/editor';
  import { TAG_CATEGORY } from '../../config/const';

  export default {
    props: {
      mentions: {
        type: Array,
        default: () => []
      },
      keysPressed: {
        type: Array,
        required: true
      }
    },
    components: {
      'app-mention-tag': MentionTag
    },
    mounted () {
      this.categoryMentionKeys = this.getCategoryKeyList();
    },
    watch: {
      mentions () {
        this.categoryMentionKeys = this.getCategoryKeyList();
      }
    },
    methods: {
      callDeleteMentionTag({ tag, organization }) {
        this.$emit('deleteMentionTag', { tag, organization });
      },
      stringToClass (string) {
        return editor.stringToClass(string);
      },
      getTagScore (tag, positive) {
        return editor.getTagScore(tag, positive)
      },
      //get a list of category keys, mentioned in the organization
      getCategoryKeyList() {
        let categoryKeys = {};
        _.map(this.mentions, (tag) => {
          if (
            (tag.category === TAG_CATEGORY.ARTICLE_LEVEL ||
              tag.category === TAG_CATEGORY.ARTICLELEVEL ||
              tag.category === TAG_CATEGORY.MEDIA_TAG) &&
            tag.category !== TAG_CATEGORY.ORGANIZATION &&
            !categoryKeys[tag.parent] && tag.cat_id === tag?.tag_category?.id
          ) {
            categoryKeys[tag.parent] = tag.tag_category;
          }
        });
        return categoryKeys;
      },
      onArticleMentionsClick (e) {
        const overflow = {
          enabled: true,
          xCoordinate: e.clientX,
          yCoordinate: e.clientY
        };
        const categoryKey = e.target.closest('[category-key]') ? e.target.closest('[category-key]').getAttribute('category-key') : undefined;
        //Show overflowing menu
        this.$emit('toggleCategories', overflow, parseInt(categoryKey));
      },
      getRelationTag(tag) {
        return _.cloneDeep(tag.relation_tag);
      }
    },
    data () {
      return {
        categoryMentionKeys: []
      }
    }
  }
</script>